module.exports = __webpack_public_path__ + "img/mobile-p.0fb0f92a.png";